import { render, staticRenderFns } from "./StudentsStatCard.vue?vue&type=template&id=0d6e7654&scoped=true&"
import script from "./StudentsStatCard.vue?vue&type=script&lang=js&"
export * from "./StudentsStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e7654",
  null
  
)

export default component.exports